<template>
  <el-card>
    <h4 class="card-title" v-if="lang == 'en'"><span class="color-primary">{{ data.length }}</span> related results</h4>
    <h4 class="card-title" v-else>相关结果 <span class="color-primary">{{ data.length }}</span> 条</h4>
    <div class="card-content" v-if="data && data.length">
      <div class="data-list">
        <policy-express-item v-for="(item, index) in data" :key="item.id" :data="item" :index="index" @read="policyExpressItemClick"></policy-express-item>
      </div>
      <bsp-pagination :pager-config.sync="pagerConfig" @page-change="pageChange"></bsp-pagination>
    </div>
    <bsp-empty small-empty v-else></bsp-empty>
  </el-card>
</template>

<script>
  import PolicyExpressItem from '@/views/policy/policyLibrary/policyExpress/components/PolicyExpressItem';
  import * as api from '@/api/policy/policyLibrary';
  import { mapGetters } from 'vuex';
  export default {
    name: "SearchResult",
    components: {
      PolicyExpressItem
    },
    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      },
      pagerConfig: {
        type: Object,
        default() {
          return {
            page: 1,
            limit: 10,
            total: 0
          }
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      // 单项点击，设为已读同时跳转至详情页
      policyExpressItemClick({ index, data, type }) {
        const { id, essayUrl } = data;
        api.expressRead({ id })
          .then(res => {
            this.data[index].read = 1;
          })
        window.open(essayUrl);
      },
      pageChange({ type, currentPage, pageSize }) {
        this.$emit('page-change', { type, currentPage, pageSize });
      }
    },
    computed: {
      ...mapGetters(['lang'])
    }
  }
</script>

<style scoped>

</style>
